import { render } from "./ReleaseTimes.vue?vue&type=template&id=21e89a0d&scoped=true"
import script from "./ReleaseTimes.vue?vue&type=script&lang=js"
export * from "./ReleaseTimes.vue?vue&type=script&lang=js"

import "./ReleaseTimes.vue?vue&type=style&index=0&id=21e89a0d&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e89a0d"]])

export default __exports__